if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	$('.sym-slides').slick()

	const SLIDER_SELECTOR$1 = '[data-slick="single-quad-slider"]'

	// slickListSingleQuad
	const slickListSingleQuad = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$1)

		slickElements.forEach((element) => {
			$(element).slick({
				fade: true,
				cssEase: 'linear',
				arrows: false,
				dots: true,
				autoplay: true,
			})
		})
	}

	// init sliders
	slickListSingleQuad()

	var req = document.getElementById('vip-form_yes-signup-form')
	if (req !== null) {
		req.classList.add('required')
	}
})()

document.addEventListener("DOMContentLoaded", () => {
	if(document.querySelector('#vip-form_yes-signup-form')){
		document.querySelector('#vip-form_yes-signup-form').classList.remove('required');
		let principalHomeForm = document.querySelector('#vip-form');
		principalHomeForm.querySelectorAll(".gdpr-wrapper .field.gdpr label").forEach(element => {
			element.click();
		});
	}



})
